import { useIntl } from 'react-intl';

export const SearchErrorMessage = ({ searchText }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="text-center h-[300px] flex flex-col justify-center ">
      <p className="text-white">{formatMessage({ id: 'search.emptyView.title' })}</p>
      <p className="text-brand-neutral-300">
        {formatMessage({ id: 'search.emptyView.description' }, { searchText })}
      </p>
    </div>
  );
};
